var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer footer-black footer-white"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright pull-right"},[_vm._v(" © "+_vm._s(_vm.year)+" • Coded & designed by "),_c('a',{attrs:{"href":"https://www.solutiontech.tech","target":"_blank","rel":"noopener"}},[_vm._v("Solution Tech")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }